module.exports = __webpack_public_path__ + "img/tax-empty-image.58aee5d4.png";